module.exports = __webpack_public_path__ + "img/workspace-onboarding/explore-team-library-4ebf0df70389e7861ac0952849ab5909.png";